<style scoped>
  @import '../../../assets/css/eprendersdk.min.css';
</style>
<style lang="less">
  @import "./TakeVideo.less";
</style>
<template>
  <div class="picture">

    <van-cell-group>
      <!--<van-cell title="IMEI" icon="setting-o" :value="nowImei" is-link @click="toChangeDevPageFn" />-->
      <van-cell title="IMEI" icon="setting-o" :value="nowImei" />
      <van-cell title="摄像头" icon="award-o" :value="cameraType" is-link @click="selectCameraFn" />
      <van-cell title="视频时长" icon="award-o" :value="videoTime" is-link @click="selectVideoTimeFn" />
    </van-cell-group>

    <div class="page-btn">
      <van-button type="info" size="large" @click="takePictureFn">录制实时视频</van-button>
      <van-button type="info" size="large" plain @click="queryPictureFn">查看历史视频</van-button>
    </div>

    <div class="picture-img" v-if="imgArray && imgArray.length>0 && !showActionSheetCamera && !showActionSheetVideoTime">
      <!--<img :src="imgUrl" alt="">-->
      <div class="picture-img-list" v-for="item in imgArray" :key="item.imgUrl">
        <h4>{{item.typeName}}</h4>
        <!--<img :src="item.imgUrl" alt="">-->
        <!--方法一：播放时会自动全屏-->
        <!--<video :src="item.imgUrl" controls="controls" :poster="item.imgThumb"></video>-->
        <!--方法二：播放时不会自动全屏-->
        <div v-if="item.type===4" id='d3Video' >
          <img :src="item.url_thumb" alt="" @load='change3DVideo(item)' style="visibility: hidden;">
          <!-- <img src="../../../assets/images/play.png" alt="" class="play"> -->
          <span class="fullScreen" @click.stop='fullScreenHandle(item,"change3DVideo")'  v-show='isangle'>
            <img src="../../../assets/images/fullScreen.png" alt="" srcset="">
          </span>
        </div>
        <video controls="controls" :poster="item.url_thumb" playsinline x5-playsinline="true" v-else>
          <source :src="item.url" type="video/mp4"/>
        </video>
      </div>
    </div>

    <van-action-sheet
      v-model="showActionSheetCamera"
      title="请选择摄像头"
      round
      :actions="cameraTypeList"
      cancel-text="取消"
      @select="onSelectCameraFn"
    />
    <van-action-sheet
      v-model="showActionSheetVideoTime"
      title="请选择视频时长"
      round
      :actions="videoTimeList"
      cancel-text="取消"
      @select="onSelectVideoTimeFn"
    />
  </div>
</template>

<script>
import TakeVideo from './TakeVideo.js'
export default {
  ...TakeVideo
}
</script>
